import styled from 'styled-components';

export const GrpFieldConsole = styled.div({
  height: '36px',
  borderRadius: '5px',
  backgroundColor: 'var(--ds-bg-base)',
  border: '1px solid var(--ds-border-base)',
  display: 'flex',
  overflow: 'hidden',
  '& input': {
    backgroundColor: 'transparent',
    height: '18px',
    border: '0px solid green',
  },
  '& .mantine-SegmentedControl-root': {
    backgroundColor: 'var(--ds-bg-base)',
    borderRadius: '5px',
    padding: '4px',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: 0,
  },
  '& .mantine-SegmentedControl-control': {
    backgroundColor: 'var(--ds-bg-base)',
    border: '0px solid green',
  },
  '& .mantine-SegmentedControl-label': {
    color: 'var(--ds-text-muted)',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    padding: 2,
    margin: 3,
  },

  '& .mantine-SegmentedControl-labelActive': {
    color: 'var(ds-text-active)',
    border: '1px solid var(--ds-border-intense)',
    backgroundColor: 'transparent',
    height: '100%',
  },
  '& .mantine-SegmentedControl-active': {
    backgroundColor: 'var(--ds-bg-base)',
    border: '0px dashed green',
    boxShadow: 'none',
  },
});

export const CtnFieldMulti = styled.div({
  color: 'var(--ds-text-base)',
  '& div': {
    marginTop: '-2px',
  },
});
